<template>
  <v-card class="card   mx-auto" elevation="1">
    <v-toolbar
        color="primary"
        dark
    >
      <h2 class="py-3">
        Cancelar pedido
      </h2>
    </v-toolbar>

    <v-row class="mx-2">
      <v-col>
        <v-radio-group
            column
            v-model="refundType"
        >
          <template v-slot:label>
            <p style="font-size: 18px;color: black" class="mb-3"><strong>Selecione o tipo de cancelamento</strong></p>
          </template>

          <v-radio
              color="primary"
              :value="0"
              @click="resetRefundAmount()"
          >
            <template v-slot:label>
              <span style="font-size: 15px;color: black">Cancelamento total do pedido</span>
            </template>
          </v-radio>
          <v-radio
              color="primary"
              :value="1"
              @click="resetRefundAmount()"
          >
            <template v-slot:label>
              <span style="font-size: 15px;color: black">Cancelamento parcial do pedido</span>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row v-if="refundType == refundTotal" class="mx-2">
      <v-col cols="12">
        <h2>
          Valor total do pedido: {{
            (refundAmount - valueItemsRefund).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </h2>
      </v-col>
    </v-row>

    <v-row v-if="refundType == refundPartial && order && items && items.length > 0" class="mx-2">
      <v-col cols="12">
        <h2>
          Valor parcial do pedido: {{
            refundAmount.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </h2>
      </v-col>
      <v-col>
        <v-card elevation="1">
          <div class="span-title pa-0 ma-0 py-3 px-5 text-center">
            <span>Selcione os itens que serão cancelados</span>
          </div>
          <v-data-table
              ref="table"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum pedido encontrado"
              :headers="headers"
              :items="items"
              class="elevation-0"
              hide-default-footer
              :items-per-page="pageSize"
              :header-props="headerProps"
              :key="componentKey"
              v-model="selectedItems"
              show-select
              item-key="id"
              :single-select="false"
          >
            <template v-slot:[`item.productSku`]="{ item }">
              {{ item.productSku.attributes[0].name }}
            </template>


            <template v-slot:[`item.price`]="{ item }">
              {{
                item.price.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>


            <template v-slot:[`item.actions`]="{ item }">
              {{
                (item.qty * item.price).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
            <template v-slot:[`item.subTotal`]="{ item }">
              {{
                (item.qty * item.price).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
            <template v-slot:header.data-table-select="{ on, props}">
              <v-simple-checkbox
                  v-if="false"
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
                  :ripple="false"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
              <v-simple-checkbox
                  :ripple="false"
                  @click="addUserListSelectedUser(item)"
                  :value="isSelected"
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
              >
              </v-simple-checkbox>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="pa-0 ma-0">
      <v-col class="pa-0 ma-0">
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row class="mx-2 pa-0 ma-0">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-radio-group
            v-model="reasonForCancellation"
        >
          <template v-slot:label>
            <p style="font-size: 18px;color: black" class="mb-3"><strong>Selecione o motivo do cancelamento</strong></p>
          </template>
          <v-radio
              v-for="reasonForCancellation in reasonsForCancellation"
              :key="reasonForCancellation.key"
              :label="reasonForCancellation.text"
              :value="reasonForCancellation.key"
              @change="setReasonForCancellation(reasonForCancellation)"
          >
            <template v-slot:label>
              <strong class="">{{ reasonForCancellation.text }}</strong>
            </template>
          </v-radio>
          <div v-if="reasonForCancellation && reasonForCancellation == 6">
            <v-form v-model="form" :key="clear" class="pa-0 ma-0 mt-3" ref="form">
              <label>Digite a descrição do cancelamento.</label>
              <v-text-field
                  class="pa-0"
                  outlined
                  placeholder="Descrição do cancelamento"
                  v-model="descriptionOfCancellation"
                  required
                  dense
                  :rules="[rules.required, rules.min]"
              ></v-text-field>
            </v-form>
          </div>
        </v-radio-group>
          <!--<v-textarea
            class="pa-0"
            outlined
            placeholder="Descrição do cancelamento"
            v-model="descriptionOfCancellation"
            required
            :rules="[rules.required]"
        ></v-textarea>-->
      </v-col>
    </v-row>

    <v-row class="d-flex ma-0 pa-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-btn outlined class="cancelBtn mr-2" @click="close" :loading="loading">
          <span class="cancel">Cancelar</span>
        </v-btn>

        <v-btn class="okBtn mr-2" @click="action()" :loading="loading">
          <span class="yep">Confirmar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.span-title {
  background-color: #eceef1 !important;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 22px;
  color: #2d3038;
}

.input-modal {
  background: #f5f5f5 !important;
  border: 2px solid #b9b9b9 !important;
  border-radius: 16px !important;
}

.yep {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;

  color: #ffffff;
}

.cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;

  color: #2d3038;
}

.card {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 11px;
}

.cancelBtn {
  width: 200px !important;
  height: 50px !important;

  border: 2px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 6px;
}

.okBtn {
  width: 200px !important;
  height: 50px !important;

  background: #2d3038 !important;
  border-radius: 6px;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Vue from "vue";

export default {
  name: "EnviadoStatusModal",

  props: {
    order: {type: Object, default: null, require: true}
  },

  data: () => ({
    refundType: null,
    form: true,
    clear: false,
    refundTotal: 0,
    items: [],
    refundPartial: 1,
    valueItemsRefund: 0,
    loading: false,
    selectedItems: [],
    apiService: new ApiService(),
    descriptionOfCancellation: null,
    headers: [
      {
        text: "SKU",
        class: "item",
        value: "productSku",
        align: "center",
        sortable: false,
      },
      {
        text: "Produto",
        class: "item",
        value: "product.productName",
        align: "center",
        sortable: false,
      },
      {
        text: "Preço",
        class: "item",
        value: "price",
        align: "center",
        sortable: false,
      },
      {
        text: "Quantidade",
        class: "item",
        value: "qty",
        align: "center",
        sortable: false,
      },
      {
        text: "Total líquido",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: {sortByText: "Ordenar por"},
    componentKey: 1,
    pageSize: 100000,
    refundAmount: 0,
    reasonForCancellation: null,
    rules: {
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v && v.length >= 10 || "Minimo de 10 caracteres.",
    },
    reasonsForCancellation: [
      {
        key: 1,
        text: 'Indisponibilidade de estoque',
      },
      {
        key: 2,
        text: 'Produto em má qualidade no estoque (sem condições de envio)',
      },
      {
        key: 3,
        text: 'Dados de entrega incorretos ou incompletos',
      },
      {
        key: 4,
        text: 'Impossibilidade de envio dentro do prazo estipulado',
      },
      {
        key: 5,
        text: 'Divergência entre o valor de frete pago pelo cliente e o valor real do transporte',
      },
      {
        key: 6,
        text: 'Outros',
      },
    ],

  }),
  computed: {},

  async created() {
  },

  methods: {
    addUserListSelectedUser(item) {
      const userFind = this.selectedItems.findIndex((x) => x.id === item.id)
      if (userFind > -1) {
        this.selectedItems.splice(userFind, 1)
      } else {
        this.selectedItems.push(item)
      }
      if (this.selectedItems.length == this.items.length) {
        this.selectedItems.shift()
      }
      this.refundAmount = this.selectedItems.reduce((acumulador, produto) => acumulador + (produto.price * produto.qty), 0)
    },

    close() {
      this.$emit("close");
    },

    resetRefundAmount() {
      this.refundAmount = 0;
      this.selectedItems = [];
      if (this.refundType == this.refundTotal) {
        this.refundAmount = this.order.totalPrice + this.order.fretePrice + this.order.installmentsInterest
      }
      this.items = this.order.items.filter(x => !x.refundDate)
      this.valueItemsRefund = this.order.items
          .filter(x => x.refundDate)
          .reduce((acumulador, produto) => acumulador + (produto.price * produto.qty), 0)
    },

    setReasonForCancellation(reasonForCancellation){
      this.reasonForCancellation = reasonForCancellation
      this.descriptionOfCancellation = null
      if(reasonForCancellation.key == 6){
        this.descriptionOfCancellation = null
        return
      }
      this.descriptionOfCancellation = reasonForCancellation.text
    },

    action() {
      if (this.refundType == null) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Selecione o tipo de cancelamento.",
          trace: null,
        });
        return;
      }

      if (this.refundType == this.refundPartial && this.refundAmount <= 0) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Selcione os itens que serão cancelados.",
          trace: null,
        });
        return;
      }

      if (!this.reasonForCancellation) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Selecione o motivo do cancelamento",
          trace: null,
        });
        return;
      }

      if (this.reasonForCancellation == 6 && !this.$refs.form.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite a descrição do cancelamento.",
          trace: null,
        });
        return;
      }
      this.order.descriptionOfCancellation = this.descriptionOfCancellation
      const refund = {
        ...this.order,
        refundAmount: this.refundAmount,
        refundType: this.refundType,
        items: this.selectedItems,
        reasonForCancellation: this.reasonForCancellation,
      }
      this.$emit("action", {...refund});
    },
  },
};
</script>
